import VSearch from './Search.vue';
import VForm from './Form.vue';
import VGrid from './Grid.vue';
import VHeader from './Header.vue';
import VModal from './Modal.vue';
import VSideNavigation from './SideNavigation.vue';

const components = {
  VSearch,
  VForm,
  VGrid,
  VHeader,
  VModal,
  VSideNavigation,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
  },
};

export {
  VSearch,
  VForm,
  VGrid,
  VHeader,
  VModal,
  VSideNavigation,
};
